export default __webpack_public_path__ + "static/media/i226hp.a761ae9f.webp";